import React from 'react'
import { Navbar, Image, NavDropdown, Nav, Button } from "react-bootstrap"
import { FaUser,FaExpand, FaFileInvoiceDollar, FaBell, FaCogs } from 'react-icons/fa'
import { FiLogOut } from "react-icons/fi"

const Topbar = () => {
    const nextButtonHandler = () => {
        document.getElementById("content").style.marginLeft = "87px";
        document.getElementById("content").style.transition= "margin-left .5s";
        document.getElementById("accordior").style.display = "";
        document.getElementById("accordior").style.transition= "margin-right .5s";
        document.getElementById("btnSidebarOpen").style.display = "none";
        document.getElementById("btnSidebarClose").style.display = "";
    }

    const previousButtonHandler = () => {
        document.getElementById("accordior").style.display = "none";
        document.getElementById("content").style.marginLeft = "0";
        document.getElementById("content").style.transition= "margin-left .5s";
        document.getElementById("btnSidebarClose").style.display = "none";
        document.getElementById("btnSidebarOpen").style.display = "";
    }
    return (
        /* <!-- Topbar --> */
        <Navbar bg="dark" variant="light" className="navbar navbar-expand navbar-light bg-white topbar mb-3 static-top shadow">
            <div className="sidebar-brand d-flex align-items-center justify-content-center" style={{backgroundColor: 'white', padding: '0.7rem 0rem'}}>
                <Button id="btnSidebarOpen" variant='light' className="btn btn-link rounded-circle" onClick={() => nextButtonHandler()} style={{display: 'none'}}>☰</Button>  
                <Button id="btnSidebarClose" variant='light' className="btn btn-link rounded-circle" onClick={() => previousButtonHandler()}>☰</Button>
            </div>
            
            {/* <!-- Sidebar - Brand --> */}
            <Nav.Link className="sidebar-brand d-flex align-items-center justify-content-center ml-4" to="/">
                <div className="sidebar-brand-text"><Image src={require('../img/expenzelogo.jpg')} className="expLogo" /></div>
            </Nav.Link>

            {/* <!-- Topbar Navbar --> */}
            <Nav as="ul" className="navbar-nav ml-auto">
                
                <NavDropdown id="basic-nav-dropdown" className="nav-item dropdown no-arrow p-0" align="end"
                    // title={
                    //     <Nav.Link className="nav-link dropdown-toggle" href="/" id="alertsDropdown" role="button"
                    //         data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    //         <FaBell className="fas fa-fw icon" />
                    //         {/* <!-- Counter - Alerts --> */}
                    //         <span className="badge badge-danger badge-counter">3+</span>
                    //     </Nav.Link>
                    // }
                    disabled
                    >
                    {/* <h6 className="dropdown-header"> Alerts Center</h6>
                    <NavDropdown.Item className="dropdown-item" href="/">
                        <div className="mr-3">
                            <div className="icon-circle bg-primary">
                                <FaFileInvoiceDollar className="fas fa-fw text-white" />
                            </div>
                        </div>
                        <div>
                            <div className="small text-gray-500">December 12, 2019</div>
                            <span className="font-weight-bold">A new monthly report is ready to download!</span>
                        </div>
                    </NavDropdown.Item>
                    <NavDropdown.Item className="dropdown-item" href="/">
                        <div className="mr-3">
                            <div className="icon-circle bg-success">
                                <FaFileInvoiceDollar className="fas fa-fw text-white" />
                            </div>
                        </div>
                        <div>
                            <div className="small text-gray-500">December 7, 2019</div>
                            $290.29 has been deposited into your account!
                        </div>
                    </NavDropdown.Item>
                    <NavDropdown.Item className="dropdown-item" href="/">
                        <div className="mr-3">
                            <div className="icon-circle bg-warning">
                                <FaFileInvoiceDollar className="fas fa-fw text-white" />
                            </div>
                        </div>
                        <div>
                            <div className="small text-gray-500">December 2, 2019</div>
                            Spending Alert: We've noticed unusually high spending for your account.
                        </div>
                    </NavDropdown.Item> */}
                </NavDropdown>

                {/* <Nav.Link className="dropdown dropdown-list-toggle header-fullscreen pt-2 p-0" href="/home">
                    <div className="nav-link full-screen-link" id="fullscreen-button">
                        <FaExpand className="fas fa-fw icon" />
                    </div>
                </Nav.Link> */}

                <div className="topbar-divider d-none d-sm-block"></div>
                <NavDropdown id="basic-nav-dropdown" className="nav-item dropdown no-arrow"
                    title={
                        <Nav.Link className="nav-link dropdown-toggle" href="/">
                            <span className="mr-2 d-none d-lg-inline text-gray-600 small">{localStorage.getItem('username')}</span>
                        </Nav.Link>
                    }>
                    <NavDropdown.Item className="dropdown-item" href="/"><FaUser className="fa-sm fa-fw mr-2 text-gray-400" />Profile</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item className="dropdown-item" href="/"><FaCogs className="fa-sm fa-fw mr-2 text-gray-400" />Settings</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item className="dropdown-item" href="/" onClick={()=>{localStorage.clear()}}><FiLogOut className="fa-sm fa-fw mr-2 text-gray-400" />Logout</NavDropdown.Item>
                </NavDropdown>

            </Nav>
        </Navbar>
    ) 
}
export default Topbar;